import { Authenticated } from "convex/react";
import {
  createFileRoute,
  Outlet,
  Navigate,
  redirect,
} from "@tanstack/react-router";
import { useAuth } from "@clerk/clerk-react";
import { Header } from "@/components/header";
import { useQuery } from "convex/react";
import { api } from "../../convex/_generated/api";
import { TermsModal } from "@/components/TermsModal";

export const Route = createFileRoute("/app")({
  component: AppLayout,
  beforeLoad: ({ location }) => {
    if (location.pathname === "/app") {
      throw redirect({ to: "/app/search" });
    }
  },
});

function AppLayout() {
  const { isSignedIn } = useAuth();
  const hasAccepted = useQuery(api.data.hasAcceptedTerms);

  if (!isSignedIn) {
    return <Navigate to="/login" />;
  }

  return (
    <Authenticated>
      <div className="min-h-screen bg-background text-foreground">
        <Header />
        <TermsModal open={hasAccepted === false} />
        <Outlet />
      </div>
    </Authenticated>
  );
}
